import React from 'react';
import { Quote, ArrowRight, MapPin } from 'lucide-react';
import { founder } from '../data/mock';
import { Reveal } from './Reveal';
import CountUp from './CountUp';
import { BOOKING_URL, CTA_LABEL } from '../data/constants';

const stats = [
  { value: 200, suffix: '+', label: 'Unternehmen betreut' },
  { value: 5, suffix: '.0', label: 'Bewertung (50+ Reviews)', format: false },
  { value: 24, suffix: 'h', label: 'bis zum ersten Kandidaten' },
];

const AboutSection = () => (
  <section id="about" className="relative bg-cream py-24 lg:py-32 overflow-hidden" data-testid="about-section">
    <div className="absolute -right-32 top-0 w-[600px] h-[600px] rounded-full bg-violet-200/40 blur-[140px] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5 flex flex-col items-center lg:items-start" data-testid="founder-portrait">
        <div className="relative w-64 sm:w-72">
          <div className="absolute -inset-6 bg-violet-500/15 blur-[60px] rounded-full" />
          <div className="gold-ring relative">
            <div className="relative aspect-square overflow-hidden bg-anthracite">
              <img src={founder.image} alt={founder.name} className="w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
          <div className="absolute -bottom-4 -right-6 glass-light rounded-2xl px-4 py-3 shadow-xl float-slow">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-semibold">Gegründet in</p>
            <p className="font-display font-extrabold text-lg text-slate-900 leading-tight">Hamburg</p>
          </div>
        </div>
        <div className="mt-10 text-center lg:text-left">
          <p className="font-display font-extrabold text-2xl text-slate-900">{founder.name}</p>
          <p className="text-violet-700 font-medium">{founder.role}</p>
          <p className="text-slate-500 text-sm mt-1 inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5 text-amber-500" /> {founder.city}</p>
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        <Reveal>
          <span className="eyebrow text-violet-700"><span className="eyebrow-line" />Über uns</span>
          <h2 className="mt-6 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08] text-slate-900">
            Recruiting, wie es sein sollte: <span className="text-violet-gradient">schnell, fair, persönlich.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-8 relative pl-6 border-l-2 border-amber-400">
          <Quote className="absolute -top-3 -left-4 w-8 h-8 text-amber-400 fill-amber-400/20" />
          <p className="text-lg md:text-xl text-slate-800 leading-relaxed font-display font-medium italic">„{founder.quote}“</p>
          <p className="mt-4 text-sm text-slate-500">— {founder.name}, Gründer HIREKA</p>
        </Reveal>

        <Reveal delay={0.2} className="mt-8 text-slate-600 leading-relaxed text-base md:text-lg">
          HIREKA wurde in Hamburg gegründet, um den Recruiting-Markt neu zu denken. Statt Provisionen vom Gehalt ein Festpreis. Statt Wochen 24 Stunden.
          Statt weitergeleiteter Lebensläufe gebriefte Menschen, die zu deinem Team passen – und wenn nicht, besetzen wir kostenlos nach.
        </Reveal>

        <Reveal delay={0.3} className="mt-10 grid grid-cols-3 gap-4" data-testid="about-stats">
          {stats.map((s, i) => (
            <div key={i} className="lux-card p-5">
              <div className="font-display text-3xl lg:text-4xl font-extrabold text-slate-900"><CountUp to={s.value} suffix={s.suffix} format={s.format !== false} /></div>
              <p className="mt-1 text-xs md:text-sm text-slate-500">{s.label}</p>
            </div>
          ))}
        </Reveal>

        <Reveal delay={0.4} className="mt-10">
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-lux px-8 py-4 text-base" data-testid="about-cta-btn">
            {CTA_LABEL} <ArrowRight className="w-5 h-5" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default AboutSection;
